export default __webpack_public_path__ + "static/media/3s-Photo-3.c4a2f2b9.jpg";